import React from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom';

export interface WithRouterProps {
  navigate: (path: string) => void;
  params: any;
  location: any;
}

export const withRouter = (Component: any) => {
  const Wrapper = (props: any) => {
    const navigate = useNavigate();
    const params = useParams()
    const location = useLocation()
    return (
      <Component
        navigate={navigate}
        params={params}
        location={location}
        {...props}
        />
    );
  };
  
  return Wrapper;
};